import styled, { css } from 'styled-components';

export const Content = styled.div`
  display: flex;
  width: 100px;
  height: 100%;
  padding: 6px 6px 6px 8px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 4px;
  background: var(--grey100);
  ${(props) =>
    !!props.isReadonly &&
    css`
      background-color: transparent;
    `}
`;
